import * as React from "react";
const SVGComponent = (props) => (
    <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.20687 8.22656L6.79688 3.64656L11.3869 8.22656L12.7969 6.81656L6.79688 0.816563L0.796875 6.81656L2.20687 8.22656Z" fill="black" fill-opacity="0.54" />
    </svg>
);
export default SVGComponent;
